module.exports = __webpack_public_path__ + "static/media/closeCross3.600cb9f7.svg";